import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFlag,
  FaCopy,
} from "react-icons/fa";
import { useSelector } from "react-redux";

const ReferralModal = ({
  handleCloseOrderModal,
  isOrderDetail,
  referralData,
}) => {
  const [copied, setCopied] = useState(false);
  const {
    email = "N/A",
    first_name = "Unknown",
    last_name = "",
    phone_number = "N/A",
    country,
    referral_code,
    average_rating,
    status,
    is_active,
    redeem_points,
    referral_count,
    referral_amount,
    createdAt,
  } = referralData;

  const { theme } = useSelector((state) => state.theme);

  const handleCopy = () => {
    navigator.clipboard.writeText(referral_code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (referralData) {
    return (
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-lg mx-auto">
        {/* User Header */}
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-20 h-20 bg-gradient-to-br capitalize from-pink-300 to-red-300 rounded-full flex items-center justify-center text-2xl font-bold text-white">
            {first_name.charAt(0)}
          </div>
          <div>
            <h2 className="text-3xl font-semibold capitalize text-gray-900">
              {`${first_name} ${last_name}`}
            </h2>
            <p
              className={`text-md ${
                is_active ? "text-green-600" : "text-red-600"
              }`}
            >
              {status}
            </p>
          </div>
        </div>

        {/* Beautiful Contact Info Section */}
        <div className="p-6 rounded-lg bg-gradient-to-r from-pink-100 to-red-100 text-gray-800 space-y-4 mb-6 shadow-md">
          <h3 className="text-xl font-bold mb-4">Contact Info</h3>

          <div className="flex items-center mb-3">
            <FaEnvelope className="mr-3 text-xl text-[var(--color--2)]" />
            <div className="flex gap-2">
              <p className="font-medium">Email :</p>
              <span className="text-md text-gray-600">{email}</span>
            </div>
          </div>

          <div className="flex items-center mb-3 clear-none ">
            <FaPhoneAlt className="mr-3 text-xl text-[var(--color--2)]" />
            <div>
              <p className="font-medium">Phone</p>
              <span className="text-md text-gray-600">{phone_number}</span>
            </div>
          </div>

          <div className="flex items-center">
            <FaMapMarkerAlt className="mr-3 text-xl text-[var(--color--2)]" />
            <div>
              <p className="font-medium">Location</p>
              <span className="text-md text-gray-600">
                {country?.name || "N/A"}
              </span>
            </div>
            {country?.flag && (
              <img
                src={country.flag}
                alt="Country Flag"
                className="ml-4 w-6 h-4 self-end rounded-sm shadow-md"
              />
            )}
          </div>
        </div>

        {/* Referral Code with Enhanced UI */}
        <div className="relative bg-gradient-to-r from-[var(--color--2)] to-red-500 p-4 rounded-lg shadow-lg text-white flex justify-between items-center mb-6">
          <div>
            <h3 className="text-lg font-semibold">Referral Code</h3>
            <p className="text-2xl font-bold mt-2">{referral_code}</p>
          </div>
          <button
            onClick={handleCopy}
            className="ml-4 bg-white text-[var(--color--1)] px-4 py-2 rounded-md text-sm font-medium flex items-center space-x-2 hover:bg-gray-200"
          >
            <FaCopy />
            <span>{copied ? "Copied!" : "Copy"}</span>
          </button>
        </div>

        {/* Referral Stats */}
        <div className="mt-6">
          <h3 className="text-xl font-bold text-gray-900">Referral Stats</h3>
          <div className="grid grid-cols-2 gap-6 mt-4">
            <div className="p-4 bg-gradient-to-r from-pink-100 to-red-100 rounded-lg text-center shadow-md">
              <h4 className="text-lg font-semibold text-[var(--color--1)]">
                {referral_count}
              </h4>
              <p className="text-gray-600">Referral Count</p>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-100 to-red-100 rounded-lg text-center shadow-md">
              <h4 className="text-lg font-semibold text-[var(--color--1)]">
                {referral_amount}
              </h4>
              <p className="text-gray-600">Referral Amount</p>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-100 to-red-100 rounded-lg text-center shadow-md">
              <h4 className="text-lg font-semibold text-[var(--color--1)]">
                {redeem_points}
              </h4>
              <p className="text-gray-600">Redeem Points</p>
            </div>
            <div className="p-4 bg-gradient-to-r from-pink-100 to-red-100 rounded-lg text-center shadow-md">
              <h4 className="text-lg font-semibold text-[var(--color--1)]">
                {average_rating}
              </h4>
              <p className="text-gray-600">Average Rating</p>
            </div>
          </div>
        </div>

        {/* Joined Date */}
        <div className="mt-8 text-center">
          <p className="text-gray-500 text-md">
            Joined on: {new Date(createdAt).toLocaleDateString()}
          </p>
        </div>
      </div>
    );
  }
};

export default ReferralModal;
